webpackJsonp([188429276130593],{

/***/ 211:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(22);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(14);
	
	__webpack_require__(13);
	
	var _reactLinkedinInsight = __webpack_require__(20);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	__webpack_require__(35);
	
	__webpack_require__(93);
	
	__webpack_require__(211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/AishwaryaJaishankar.jpg";
	var icon2 = "https://winpeforum.com/assets/elements/NandikaPradeep.png";
	var icon3 = "https://winpeforum.com/assets/elements/SunithaViswanathan.jpg";
	var icon5 = "https://winpeforum.com/assets/elements/SaloniJhaveri.png";
	var icon6 = "https://winpeforum.com/assets/elements/ShivaniBhasin.png";
	var icon4 = "https://winpeforum.com/assets/elements/Lizzie.png";
	
	var duration = 400;
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var WinPEEdge = function (_Component) {
	  _inherits(WinPEEdge, _Component);
	
	  // constructor() {
	  //   super();
	  //   this.state = {
	  //     isShow: false,
	  //     activeItem: {},
	  //   };
	  // }
	
	  // togglePopUp = (item) => {
	  //   this.setState({
	  //     isShow: !this.state.isShow,
	  //     activeItem: item || {},
	  //   });
	  // };
	  function WinPEEdge(args) {
	    _classCallCheck(this, WinPEEdge);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.Speaker1 = [{
	      imgUrl: icon1,
	      desc: "<div>\n        Aishwarya Jaishankar is the Co-founder and COO of Hyperface Technologies, Asia\u2019s first Credit Card-as-a-Service platform for cobrands.\n<br/><Br/>\n\nPassionate about reimagining banking and money management, Aishwarya is known for challenging the status quo and building products that deliver 10X\u2013100X impact. Her work spans pioneering Aadhaar OTP\u2013based customer onboarding, leading a global bank\u2019s digital overhaul, and now shaping next-generation credit card experiences at Hyperface.\n<br/><Br/>\n\n A career digital banker, she has driven multiple high-impact digital transformations for leading banks, including Kotak Mahindra Bank and HSBC India.\n<br/><br/>\n\nRecognised among the Top 60 LinkedIn Voices in India Fintech by Favikon, her contributions have earned accolades such as Finnoviti, MMA Smarties, and the Mastercard Innovation Award. She has also been featured in industry lists including Top Women in Fintech, AWS BuildHer, and was shortlisted for Fintech Woman of the Year by BFF.\n<br/><br/>\n\nAishwarya also serves on the Executive Committee of the India Fintech Forum, where she actively contributes to shaping the future of the fintech ecosystem. A career digital banker, she has driven multiple high-impact digital transformations for leading banks, including Kotak Mahindra Bank and HSBC India.\n\n\n          \n              </div>",
	      name: "Aishwarya Jaishankar",
	      post: "<div>Co- Founder & COO<br/>\n          Hyperface.co\n\n          </div>"
	    }, {
	      imgUrl: icon2,
	      desc: "<div>\n       Nandika has a deep passion for building organizations while keeping the founder\u2019s soul and vision at the center. Her expertise lies in translating organizational aspirations into execution realities by connecting people, strategy, and execution.  <br/><br/>\nIn her 15+ years of experience, Nandika has played various roles starting from being a consultant at Aon Hewitt, to leading multiple functional areas within HR globally at InMobi, to working alongside the founders driving business strategy, growth and operational excellence as part of InMobi's leadership team.<br/><br/>\nAt Fireside, she leads Strategy and People - She works on understanding where the consumer is headed, shaping the fund\u2019s long-term outlook, and strengthening the organization for scale. She partners closely with portfolio companies across multiple growth vectors, helping them navigate their next stage of evolution. In her role, she also meets with multiple founders ahead of investments, understanding their vision, leadership approach, and potential to scale.<br/><br/>\nNandika holds an MBA from ISB Hyderabad and a BA (Honours) in Economics from LSR, Delhi University.\n\n            </div>",
	      name: "Nandika Pradeep",
	      post: "<div>Director, Strategy & Human Capital<br/>Fireside Ventures\n \n     \n            </div>"
	    }, {
	      imgUrl: icon3,
	      desc: "<div>\n Sunitha Viswanathan is a Partner at Kae Capital. Prior to joining Kae Capital, she spent over 8 years with Unitus Ventures, a leading early-stage VC fund in Bangalore. At Unitus, she served on the boards of Cuemath, Masai School, Salesken, Awign, Blowhorn among others. Prior to Unitus Ventures, she worked with a technology startup in Bangalore. She has over a decade of experience spanning venture investment, banking and technology. Her experience also includes working with mid-market clients at Yes Bank. In addition to investing, Sunitha is also on the Board of Trustees of Mentor Together (India\u2019s largest mentoring organisation for underprivileged children).\n<Br/><br/>\nSunitha received her Bachelor\u2019s degree in Electronics and Communications Engineering from PES Institute of Technology, Bangalore and a Master\u2019s degree in Finance from S.P. Jain Institute of Management & Research, Mumbai. She has also cleared all 3 Levels of the program offered by the CFA Institute (USA).\n\n </div>",
	      name: "Sunitha Viswanathan",
	      post: "<div>Partner<br/> Kae Capital\n \n            </div>"
	    }];
	
	    _this.Speaker2 = [{
	      imgUrl: icon2,
	      desc: "Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.\n<br/><br/>\nAt McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.\n\n\n         ",
	      name: "Alka Goel",
	      post: "<div>Founding Partner<br/> Alkemi Growth Capital\n        </div>"
	    }];
	
	    return _this;
	  }
	
	  WinPEEdge.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  WinPEEdge.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  WinPEEdge.prototype.render = function render() {
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "sheshines with Winpe",
	        image: "https://winpeforum.com/assets/elements/sheshineswebpage1.png",
	        description: "Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions!",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                " Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "h1",
	              { className: "ignite-ask-me-anything__heading" },
	              "sheshines with Winpe "
	            ),
	            _react2.default.createElement("hr", { className: "ignite-ask-me-anything__hr" }),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text" },
	              _react2.default.createElement(
	                "b",
	                null,
	                "she"
	              ),
	              "shines with Winpe are in-person networking sessions for women in the investing and entrepreneurship ecosystem.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The importance of building strong networks cannot be underscored too much. The number of women in investing and entrepreneurship continues to be small and the imperative for everyone to know each other, support each other and leverage each other is that much stronger.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Through these events, Winpe attempts to bring women together to meet old friends and make new ones.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "b",
	                null,
	                "she"
	              ),
	              "shines events include interactive, candid and close-range discussions with senior women leaders and women champions from various fields and of course, lots of networking.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "b",
	                null,
	                "she"
	              ),
	              "shines will be in Mumbai, Bangalore & Delhi/Gurgaon every quarter.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null)
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "tab_section container", style: { textAlign: 'center' } },
	              _react2.default.createElement(
	                "ul",
	                { "class": "nav nav-tabs justify-content-center", role: "tablist", style: { display: "inline-block" } },
	                _react2.default.createElement(
	                  "li",
	                  { "class": "nav-item" },
	                  _react2.default.createElement(
	                    "a",
	                    { "class": "nav-link  ", "data-toggle": "tab", href: "#tabs-3", role: "tab", style: { padding: "10px 5px" } },
	                    _react2.default.createElement(
	                      "h4",
	                      { style: { fontSize: '17px' }, className: "ignite-ask-me-anything__heading" },
	                      " \xA0 Mumbai\xA0  "
	                    ),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { "class": "nav-item" },
	                  _react2.default.createElement(
	                    "a",
	                    { "class": "nav-link active  ", "data-toggle": "tab", href: "#tabs-1", role: "tab", style: { padding: "10px 5px" } },
	                    " ",
	                    _react2.default.createElement(
	                      "h4",
	                      { style: { fontSize: '17px' }, className: "ignite-ask-me-anything__heading" },
	                      " \xA0  Delhi\xA0   "
	                    ),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { "class": "nav-item" },
	                  _react2.default.createElement(
	                    "a",
	                    { "class": "nav-link   ", "data-toggle": "tab", href: "#tabs-2", role: "tab", style: { padding: "10px 5px" } },
	                    _react2.default.createElement(
	                      "h4",
	                      { style: { fontSize: '17px' }, className: "ignite-ask-me-anything__heading" },
	                      " \xA0  Bangalore\xA0   "
	                    ),
	                    " "
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "tab-content" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab-pane active", id: "tabs-1", role: "tabpanel" },
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "eventlist_listing eventlist_listing_new" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "February 17, 2026 (5:00 PM - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "Jaypee Vasant Continental, New Delhi"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines17Feb2026/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          " ",
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    "  ",
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "September 24, 2025 (5:00 PM - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "Google office, Gurgaon"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "AI as the New Co-Founder You Didn\u2019t\xA0Know\xA0You\xA0Needed"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines24Sep2025/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          " ",
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "February 6, 2025 (5:00 PM - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "Jaypee Vasant Continental, Vasant Vihar, New Delhi"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines6Feb2025/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          " ",
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    "  ",
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "August 7, 2024 (5:00 PM - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Navigating the Investor - Founder relationship"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "Delhi NCR"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines7Aug2024/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("hr", null),
	                          _react2.default.createElement("hr", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "January 24, 2024 (5:00 PM - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Networking works"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "Delhi NCR"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines24Jan2024/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("hr", null),
	                          _react2.default.createElement("hr", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "July 27, 2023 (5:00 PM - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Journeys: Women &\xA0Leadership"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "JW Marriott, Aerocity, New Delhi"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines27July2023/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "August 25, 2022 (5:00 PM - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Networking works"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "Hotel Andaz, Aerocity - Delhi"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines25Aug2022/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("hr", null),
	                          _react2.default.createElement("hr", null),
	                          _react2.default.createElement("br", null),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          "        ",
	                          _react2.default.createElement("br", null),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          "        ",
	                          _react2.default.createElement("br", null),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          "        ",
	                          _react2.default.createElement("br", null),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          "        ",
	                          _react2.default.createElement("br", null),
	                          " ",
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab-pane ", id: "tabs-2", role: "tabpanel" },
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "eventlist_listing eventlist_listing_new" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "December 11, 2025 (5:00 - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            { style: { fontSize: '16px' } },
	                            "From Idea to Impact: What Investors Look For \u2014 The said and the unsaid"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "Bangalore International Centre"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines11Dec2025/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          " ",
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "June 19, 2025 (5:00 - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            { style: { fontSize: '16px' } },
	                            "The Founder-Investor Dance: Building High-Trust Relationships That Win"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "  Bangalore"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines19June2025/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "h4",
	                              null,
	                              "Hosted By:"
	                            ),
	                            _react2.default.createElement("img", { src: "https://winpeforum.com/assets/elements/epicworld-removebg-preview.png", style: { width: '100px' } })
	                          ),
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "November 28, 2024 (4:00 - 7:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              " Wink, Vivanta, Bengaluru"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/Sheshines28Nov2024/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "h4",
	                              null,
	                              "In collaboration with:"
	                            ),
	                            _react2.default.createElement("img", { src: "https://winpeforum.com/assets/elements/vivanta.png", style: { width: '400px' } })
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "May 23, 2024 (5:00 - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "  Bangalore International Centre"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines23May2024/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "August 24, 2023 (5:00 PM - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "Bangalore International Centre "
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines24Aug2023/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "January 19, 2023 (4:00 PM - 7:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Journeys: Women & Leadership"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "Jook Taproom, Indiranagar, Bangalore"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines19Jan2023/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null)
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "eventlist_listing eventlist_listing_new" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "June 30, 2022 (5:00 PM - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Networking Works: Leveraging Networks for Growth and Success"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "Kaz\xE9, Bangalore"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines30June2022/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab-pane     ", id: "tabs-3", role: "tabpanel" },
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "eventlist_listing eventlist_listing_new" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "November 6, 2025 (5:00 - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Up Close with A91 Partners: Building a differentiated investment firm"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              " A91 Partners Office, Mumbai"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "h4",
	                              null,
	                              "Hosted By:"
	                            ),
	                            " ",
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement("img", { src: "https://winpeforum.com/assets/elements/A91_Final.jpeg", style: { width: '60px' } })
	                          ),
	                          "      ",
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines06Nov2025/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "October 17, 2024 (5:00 - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              " Motilal Oswal Tower, Prabhadevi, Mumbai"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            "Hosted by:\xA0Motilal\xA0Oswal"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines17Oct2024/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          " ",
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "October 13, 2023 (5:00 - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "The Role of Self"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              " A91 Partners, Mumbai "
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines13Oct2023/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "November 10, 2022 (5:00 - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Journey's: Women & Leadership"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "The Quorum Club, LowerParel, Mumbai"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines10Nov2022/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "April 21, 2022 (4:30 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Networking works"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "The Quorum Club, LowerParel, Mumbai"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShinesWithWinPE/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null)
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            "    ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "   ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            "        ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            "        ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            "        ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            "        ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            "        ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            "        ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            "        ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            "        ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            "        ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            "       ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            "        ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null),
	            "        ",
	            _react2.default.createElement("br", null),
	            " ",
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return WinPEEdge;
	}(_react.Component);
	
	WinPEEdge.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = WinPEEdge;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-she-shines-index-js-dc9d4c57b69ff5da00e8.js